import * as actionTypes from './actionTypes';

export const setAppLoading = (loading) => {
    loading = !!loading;
    return {
        type: actionTypes.SET_APP_LOADING,
        loading
    };
}

export const setAppStateMessage = (message) => {
    return {
        type: actionTypes.SET_APP_STATE_MESSAGE,
        message
    };
};


export const setSelectedVehicle = (vehicle) => {
    return {
        type: actionTypes.SET_APP_SELECTED_VEHICLE,
        vehicle
    };
};

export const setSelectedVehicleIndex = (index, vehicles) => {
    return {
        type: actionTypes.SET_APP_SELECTED_VEHICLE,
        index,
        vehicles
    };
}

export const changeVehicleById = (id) => {
    return async (dispatch, getState) => {
        const state = getState()
        const vehicles = state.vehicles;
        let index = vehicles.findIndex(item => +item.id === +id);
        index = index === -1 ? 0 : index;

        dispatch({
            type: actionTypes.SET_APP_SELECTED_VEHICLE,
            index,
            vehicles
        })
    }
};

export const changeVehicle = (direction = 1) => {
    return async (dispatch, getState) => {
        const state = getState()
        const vehicles = state.vehicles
        let index = state.app.selectedVehicleIndex
        if (direction) {
            if (vehicles.length > index + 1) {
                index++
            } else {
                index = 0
            }
        } else {
            if (index - 1 >= 0) {
                index--
            } else {
                index = vehicles.length - 1
            }
        }
        
        dispatch({
            type: actionTypes.SET_APP_SELECTED_VEHICLE,
            index,
            vehicles
        })
    }
};

export const setAppData = (data) => {
    return {
        type: actionTypes.SET_APP_DATA,
        data
    };
};

export const setDarkMode = (darkMode) => {
    localStorage.setItem('darkMode', darkMode);
    return {
        type: actionTypes.SET_APP_DARK_MODE,
        darkMode
    };
};